export default __webpack_public_path__ + "static/media/bg.e17c3f6b.jpg";